import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuService } from '../menu.service';
import { MainMenuItem } from '../../layout-constants';
import { Subscription } from 'rxjs';
import {ServerUrls} from "../../../server-url-constants";

@Component({
  selector: 'portal-horizontal-menu',
  templateUrl: './horizontal-menu.component.html',
  styleUrls: ['./horizontal-menu.component.scss']
})
export class HorizontalMenuComponent implements OnInit, OnDestroy {

  public menuList: MainMenuItem[] = [];
  public subscription: Subscription;
  public isNOFA: boolean = ServerUrls.IS_NOFA;

  constructor(private menuService: MenuService) {
  }

  ngOnInit(): void {
    this.subscription = this.menuService.getQuickMenus().subscribe((response) => {
      this.menuList = (response || []).filter(object => {
        if (!object) return false;
        const isVisible = object.showInMenu === undefined || object.showInMenu === true;
        const isIdmId = object.id === 'idm';
        const isIdmKey = object.rightKey === 'idm' || object.rightKey === 'manage-idm-access-control';
        const nameStr = typeof object.name === 'string' ? object.name : (object.name && object.name.en ? object.name.en : '');
        const isIdmName = nameStr.toUpperCase() === 'IDM';

        return isVisible && !isIdmId && !isIdmKey && !isIdmName;
      });
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
